/**
 * v3.18-1296 — Hub Communications Event Bus.
 *
 * Tiny wrapper around `window` CustomEvents so any component can
 * request the integrated dialer or Universal Compose without having
 * to prop-drill or share React context across page shells.
 *
 *   dispatchDial({ number, contact, client_id })
 *   dispatchCompose({ to, contact, client_id, subject })
 *
 * The receivers live in DashboardLayout (DialPadModal + ComposeAndApprove).
 */

export const HUB_DIAL_EVENT = 'hub:open-dialer';
export const HUB_COMPOSE_EVENT = 'hub:open-compose';

export function dispatchDial(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(HUB_DIAL_EVENT, { detail }));
  } catch (_e) { /* noop in SSR */ }
}

export function dispatchCompose(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(HUB_COMPOSE_EVENT, { detail }));
  } catch (_e) { /* noop */ }
}

/** Convenience listener registrar returning an unsubscribe fn. */
export function onDial(handler) {
  const wrapped = (e) => handler(e?.detail || {});
  window.addEventListener(HUB_DIAL_EVENT, wrapped);
  return () => window.removeEventListener(HUB_DIAL_EVENT, wrapped);
}

export function onCompose(handler) {
  const wrapped = (e) => handler(e?.detail || {});
  window.addEventListener(HUB_COMPOSE_EVENT, wrapped);
  return () => window.removeEventListener(HUB_COMPOSE_EVENT, wrapped);
}
